import { customToast } from "../shared";
import {
  toastTypes,
  errorMessages,
  MESSAGE_SIZE_DISPLAY,
  MESSAGE_SIZE_CONVERSION,
  MAXIMUM_MESSAGE_SIZE,
} from "../constants";
import { signalRConstants } from "../views/shared-screens/constants";

//If any update on backend
export const addListeners = ({ connection, listeners }) => {
  if (connection) {
    if (connection.state === signalRConstants.disconnectedState) {
      connection
        .start()
        .then(() => {
          listeners.forEach((key) => {
            connection.on(key);
          });
        })
        .catch((error) => {
          console.error(
            errorMessages.SIGNALR_START_LISTENERS_FAILED,
            error
          );
        });
    } else {
      listeners.forEach(({ key, callbackFunction }) => {
        connection.on(key, (newData) => {
          callbackFunction(newData);
        });
      });
    }
  }
};

//Removing listeners when component unmount
export const removeListeners = ({ connection, listeners }) => {
  if (connection) {
    if (connection.state === signalRConstants.disconnectedState) {
      connection
        .start()
        .then(() => {
          listeners.forEach((key) => {
            connection.off(key);
          });
        })
        .catch((error) => {
          console.error(
            errorMessages.SIGNALR_REMOVE_LISTENERS_FAILED,
            error
          );
        });
    } else {
      listeners.forEach((key) => {
        connection.off(key);
      });
    }
  }
};

//Send data to server
export const sendData = ({
  data,
  connection,
  resetFields,
  setIsSending,
  connectionKey,
}) => {
  const jsonString = JSON.stringify(data);
  //Get the length of the JSON string in bytes
  const dataSizeBytes = new Blob([jsonString]).size;
  //Convert bytes to megabytes
  const dataSizeMB = dataSizeBytes / MESSAGE_SIZE_CONVERSION.BYTES_PER_MEGABYTE;

  //Check if data size exceeds maxSize MB
  if (dataSizeMB > MAXIMUM_MESSAGE_SIZE) {
    customToast(
      `${errorMessages.MESSAGE_SIZE_EXCEED} (${MESSAGE_SIZE_DISPLAY.SIZE_LABEL}: ${dataSizeMB.toFixed(
        MESSAGE_SIZE_DISPLAY.DECIMAL_PLACES
      )} ${MESSAGE_SIZE_DISPLAY.MEGABYTE_UNIT_LABEL})`,
      toastTypes.ERROR
    );
    return;
  }
  if (connection) {
    setIsSending(true);
    if (connection.state === signalRConstants.disconnectedState) {
      connection
        .start()
        .then(() => {
          connection
            .invoke(connectionKey, data)
            .then(() => {
              setIsSending(false);
              resetFields();
            })
            .catch((error) => {
              setIsSending(false);
              customToast(
                errorMessages.MESSAGE_SENDING_FAILED,
                toastTypes.ERROR
              );
              console.error(`${errorMessages.SIGNALR_SEND_DATA_FAILED} ${error}`);
            });
        })
        .catch((error) => {
          console.error(
            errorMessages.SIGNALR_START_MESSAGE_SEND_FAILED,
            error
          );
        });
    } else {
      connection
        .invoke(connectionKey, data)
        .then(() => {
          setIsSending(false);
          resetFields();
        })
        .catch((error) => {
          setIsSending(false);
          customToast(
            errorMessages.MESSAGE_SENDING_FAILED,
            toastTypes.ERROR
          );
          console.error(`${errorMessages.SIGNALR_SEND_DATA_FAILED} ${error}`);
        });
    }
  }
};

//Function to run when user navigate to survey inbox
export const addToBrandGroup = async ({
  data,
  connection,
  connectionKey,
  setGroupCreated,
}) => {
  setGroupCreated(false);
  if (!connection) return;

  try {
    if (connection.state === signalRConstants.disconnectedState) {
      await connection.start();
    }
    await connection.invoke(connectionKey, data);
    setGroupCreated(true);
  } catch (error) {
    setGroupCreated(false);
    const isAccessDenied = error?.message?.includes(
      signalRConstants.invalidBrandIdError
    );
    customToast(
      isAccessDenied
        ? errorMessages.BRAND_GROUP_ACCESS_DENIED
        : errorMessages.BRAND_GROUP_JOIN_FAILED,
      toastTypes.ERROR
    );
    console.error(`${errorMessages.SIGNALR_INVOKE_FAILED} ${connectionKey}: ${error}`);
  }
};

//Function to run when user navigate from survey inbox
export const removeFromBrandGroup = ({
  connection,
  connectionKey,
  setGroupCreated,
}) => {
  if (connection) {
    if (connection.state === signalRConstants.disconnectedState) {
      connection
        .start()
        .then(() => {
          connection
            .invoke(connectionKey)
            .then(() => {
              setGroupCreated(false);
            })
            .catch((error) => {
              console.error(`${errorMessages.SIGNALR_INVOKE_FAILED} ${connectionKey}: ${error}`);
            });
        })
        .catch((error) => {
          console.error(
            `${errorMessages.SIGNALR_START_INVOKE_FAILED} ${connectionKey}:`,
            error
          );
        });
    } else {
      connection
        .invoke(connectionKey)
        .then(() => {
          setGroupCreated(false);
        })
        .catch((error) => {
          console.error(`${errorMessages.SIGNALR_INVOKE_FAILED} ${connectionKey}: ${error}`);
        });
    }
  }
};

//Function to run when user click on any conversation
export const updateConversation = ({
  connection,
  conversationId,
  connectionKey,
}) => {
  if (connection) {
    connection
      .invoke(connectionKey, conversationId)
      .then(() => {})
      .catch((error) => {
        console.error(`${errorMessages.SIGNALR_INVOKE_FAILED} ${connectionKey}: ${error}`);
      });
  }
};
